module.exports = require('component-closest');